import { computed, type Ref } from "vue"
import { Project } from "@/models/project.model"
import { KnownBusinessEntity } from "@/models/known-business-entity.model.ts"
import { type AdministrativeItem } from "@/types/models/administrative-events"

export function usePriceAgreementsConstantTimeLookup<AdministrativeItemPriceAgreement>(
  itemsRef: Ref<AdministrativeItemPriceAgreement[]>,
  keyFieldsGetter: (item: AdministrativeItemPriceAgreement) => string[],
  unitPriceGetter: (item: AdministrativeItemPriceAgreement) => string | undefined
) {
  const agreementsMap = computed(() => {
    const map = new Map()
    for (const item of itemsRef.value) {
      const key = keyFieldsGetter(item).join("-")
      map.set(key, item)
    }
    return map
  })

  function getUnitPrice(
    agreementLevel: Project | KnownBusinessEntity,
    administrativeItem: AdministrativeItem
  ): string | undefined {
    const agreement = getPriceAgreement(agreementLevel, administrativeItem)
    if (agreement) {
      return unitPriceGetter(agreement)
    }
  }

  function getPriceAgreement(
    agreementLevel: Project | KnownBusinessEntity,
    administrativeItem: AdministrativeItem
  ): AdministrativeItemPriceAgreement | undefined {
    const key = [agreementLevel.id, administrativeItem.id].join("-")
    return agreementsMap.value.get(key)
  }

  return {
    getUnitPrice,
    getPriceAgreement
  }
}
